<template>
	<TheTable
		v-if="tableData"
		:tableData="tableData"
		:loading="loading"
		:defaultSort="{ prop: 'createdDate', order: 'descending' }"
		:showMaxRows="14"
		@rowClick="goToDetailPage"
		@rowClickNewTab="goToDetailPageNewTab"
	>
		<el-table-column v-if="isUsersTable" prop="state" label="Status" :width="130" sortable>
			<template #default="scope">
				<div class="has-status" :class="`has-status--${$getStateColor('user', scope.row.status)}`">
					{{ $getStateFullLabel('user', scope.row.status) }}
				</div>
			</template>
		</el-table-column>
		<el-table-column prop="hid" label="ID" :width="110" sortable />
		<el-table-column prop="" label="Datum" :width="110" sortable>
			<template #default="scope">
				<span>{{ $formatDate(scope.row.createdDate) }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="firstName" label="Vorname" :width="160" sortable />
		<el-table-column prop="lastName" label="Nachname" :width="160" sortable />
		<el-table-column prop="" label="Gruppe" :width="160" sortable>
			<template #default="scope">
				<span>{{ scope.row.roles?.length > 0 ? scope.row.roles[0].name : '-' }}</span>
			</template>
		</el-table-column>
		<el-table-column v-if="!isUsersTable" prop="company" label="Organisation" width="200" sortable>
			<template #default="scope">
				<span>{{ scope.row.company ? scope.row.company : '-' }}</span>
			</template>
		</el-table-column>
		<el-table-column v-if="isUsersTable" prop="" label="Pro-Ethik-Siegel" width="140" sortable>
			<template #default="scope">
				<span>{{ scope.row.seal ? 'Ja' : 'Nein' }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="email" label="E-Mail" min-width="130" sortable :class-name="!isUsersTable ? 'cell--alignleft' : ''" />
		<el-table-column v-if="isUsersTable" prop="lastLogin" label="Letzter Login" width="110" sortable>
			<template #default="scope">
				<span>{{ scope.row.lastLogin ? $formatDate(scope.row.lastLogin) : '-' }}</span>
			</template>
		</el-table-column>
	</TheTable>

	<TablePagination :currentLength="tableData.length" :totalMaxVal="totalCount" @loadNextPage="$emit('loadNextPage')" />
</template>

<script lang="ts">
import { Paperclip } from '@element-plus/icons-vue';
import { defineComponent, PropType } from 'vue';
import { UserResponse } from '../../types/types';
import TheTable from '../TheTable.vue';
import TablePagination from './TablePagination.vue';

export default defineComponent({
	name: 'UsersOrContactsTable',
	components: {
		Paperclip,
		TablePagination,
		TheTable,
	},
	props: {
		isUsersTable: {
			type: Boolean,
			default: false,
		},
		tableData: {
			type: Array as PropType<UserResponse[]>,
			default: [],
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		totalCount: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {};
	},
	emits: ['loadNextPage'],
	methods: {
		goToDetailPage(row: UserResponse) {
			if (this.isUsersTable) {
				this.$router.push({ name: 'UserDetail', params: { id: String(row.id) } });
			} else {
				this.$router.push({ name: 'KontaktDetail', params: { id: String(row.id) } });
			}
		},
		goToDetailPageNewTab(row: UserResponse) {
			if (this.isUsersTable) {
				window.open(this.$router.resolve({ name: 'UserDetail', params: { id: String(row.id) } }).href, '_blank');
			} else {
				window.open(this.$router.resolve({ name: 'KontaktDetail', params: { id: String(row.id) } }).href, '_blank');
			}
		},
	},
});
</script>

<style lang="scss"></style>
